<template>
  <div>
    <a-button
      style="margin: 10px 0 10px 10px"
      v-acl="'page_device_export'"
      @click="exportDevices"
      >{{ $t("page_device_export") }}</a-button
    >
    <ml-table
      :columns="repair"
      :dataSource="dataList"
      :rowSelection="{
        selectedRowKeys,
        onChange: this.onSelectChange,
      }"
      rowKey="key"
      :selectRowKey="countId"
      :pagination="pagination"
      :custom-row="rowClick"
      style="background-color: #fff; margin: 0 10px"
    >
    </ml-table>
  </div>
</template>

<script>
import { DeviceMaterialRecordServiceProxy } from "@/service-proxies/app-v2/tpm.service-proxies";
import dayjs from "dayjs";
import { downloadFile } from "@/utils/index";
import { exportDeviceMaterial } from "@/api/api.ts";
const deviceMaterialRecordServiceProxy = new DeviceMaterialRecordServiceProxy();
// const repair = [
//   { title: "维修/保养单号", dataIndex: "recordCode" },
//   { title: "物料编码", dataIndex: "materialCode" },
//   { title: "物料名称", dataIndex: "materialName" },
//   { title: "使用数量", dataIndex: "number" },
//   { title: "使用人员", dataIndex: "userName" },
//   { title: "使用时间", dataIndex: "usageTime" },
// ];
export default {
  props: ["deviceId", "sparePartCode", "sparePartName", "sparePartType"],
  data() {
    return {
      // repair,
      dataList: [],
      countId: "",
      selectedRowKeys: [],
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
    };
  },
  computed: {
    repair() {
      return [
        {
          title: this.$t("page_device_Maintenance_recordCode"),
          dataIndex: "recordCode",
        },
        {
          title: this.$t("page_business_material_code"),
          dataIndex: "materialCode",
        },
        {
          title: this.$t("page_business_material_name"),
          dataIndex: "materialName",
        },
        { title: this.$t("page_device_user_number"), dataIndex: "number" },
        { title: this.$t("page_device_user_person"), dataIndex: "userName" },
        {
          title: this.$t("page_plan_maintenance_usage_time"),
          dataIndex: "usageTime",
        },
      ];
    },
  },
  watch: {
    deviceId: {
      handler(val) {
        if (val) {
          this.pageCheckMaterialRecord();
        }
      },
    },
  },
  created() {
    this.pagination.onChange = (currentPage) => {
      this.pagination.current = currentPage;
      this.pageCheckMaterialRecord();
    };
    this.pageCheckMaterialRecord();
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      // console.log(selectedRowKeys)
    },
    exportDevices() {
      if (
        this.deviceId &&
        this.sparePartCode &&
        this.sparePartName &&
        this.sparePartType
      )
        this.exportDeviceMaterial();
    },
    async pageCheckMaterialRecord() {
      let result = await deviceMaterialRecordServiceProxy.pageCheckMaterialRecord(
        this.pagination.current,
        this.deviceId,
        this.pagination.pageSize
      );
      this.dataList = result.records;
      this.dataList.map((item,i)=>{
        item.key =  i
      })
      this.selectedRowKeys = [];
      this.pagination.total = result.total;
      if (this.dataList.length) {
        this.selectedRowKeys.push(0);
        this.countId = 0;
      }
      if (this.dataList) {
        this.dataList.forEach((item) => {
          if (item.usageTime) {
            item.usageTime = dayjs(item.usageTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          // console.log("zasd",item.repairEndTime)
        });
      }
    },
    async exportDeviceMaterial() {
      let param = {
        deviceCode: this.sparePartCode,
        deviceName: this.sparePartName,
        deviceType: this.sparePartType,
        id: this.deviceId,
      };
      let result = await exportDeviceMaterial(param);
      downloadFile(result, "备品工况.xlsx");
    },
    rowClick(record,index) {
      return {
        on: {
          click: (event) => {
            this.countId =record.key;
            this.selectedRowKeys = [];
            this.selectedRowKeys.push(record.key);
            // console.log("aaaaaa", this.countId);
          },
        },
      };
    },
  },
};
</script>

<style scoped>
</style>
